import service from '../utils/request';

// 获取用户列表
export const getUserList = (params) => {
  console.log(params);
  return service.post('/users/normal/query', params );
};

//获取管理员列表
export const getAdminList = (params) => {
  console.log('获取管理员列表',params);
  return service.post('/users/query', params );
};


// 重置用户密码
export const resetUserPassword = (id) => {
  return service.post(`/users/${id}/reset-password`);
};


//创建管理员
export const createAdmin = (data) => {
  console.log('创建管理员',data);
  return service.post('/users', data);
};

//更新管理员
export const updateAdmin = (id, data) => {
  return service.put(`/users/${id}`, data);
};

//启用管理员
export const enableAdmin = (id) => {
  return service.put(`/users/${id}/enable`);
};

//禁用管理员
export const disableAdmin = (id) => {
  return service.put(`/users/${id}/disable`);
};
//分配管理员角色
export const assignAdminRoles = (userId, roleIds) => {
  return service.put(`/users/${userId}/roles`, roleIds );
};

//禁用普通用户
export const disableNormalUser = (id) => {
  return service.put(`/users/normal/${id}/ban`);
};

//解禁普通用户
export const enableNormalUser = (id) => {
  return service.put(`/users/normal/${id}/unban`);
};

//重置普通用户密码
export const resetNormalUserPassword = (id) => {
  return service.put(`/users/normal/${id}/password/reset`);
};

//重置管理员密码（指定新密码）
export const resetAdminPasswordWithNewPassword = (id, newPassword) => {
  return service.put(`/users/${id}/password/reset-with-password?newPassword=${encodeURIComponent(newPassword)}`);
};






